import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.contract.title',
    defaultMessage: 'Contract',
    description: 'title of the contract page',
  },
  secondaryActions: {
    requestPurge: {
      id: 'pages.contract.secondaryActions.requestPurge',
      defaultMessage: 'Request data purge',
      description: 'title of the contract page',
    },
  },
  subNavigation: {
    overview: {
      id: 'pages.contract.subNavigation.apps',
      defaultMessage: 'Apps',
      description: 'label of the apps tab on the contract page',
    },
    invites: {
      id: 'pages.contract.subNavigation.billing',
      defaultMessage: 'Billing',
      description: 'label of the billing tab on the contract page',
    },
    credentials: {
      id: 'pages.contract.subNavigation.credentials',
      defaultMessage: 'Credentials',
      description: 'label of the credentials tab on the contract page',
    },
    developerSettings: {
      id: 'pages.contract.subNavigation.developerSettings',
      defaultMessage: 'Developer settings',
      description: 'label of the developer settings tab on the contract page',
    },
  },
};

export default defineMessages(translations);
